import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { ModulesState, ModulesDetailsApiResponse, ModulesApiResponse } from '../types';

const initialState: ModulesState = {
  groups: [],
  modules: [],
  moduleDetails: undefined!,
  modulesInfo: undefined!,
};

const modulesSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {
    setModulesAction(state, action: PayloadAction<ModulesApiResponse>) {
      state.groups = action.payload.timelineGroups;
      state.modules = action.payload.timelineCards;
      state.modulesInfo = action.payload;
    },

    clearModulesAction(state) {
      state.groups = [];
      state.modules = [];
      state.modulesInfo = undefined!;
    },

    setModuleDetailsAction(state, action: PayloadAction<ModulesDetailsApiResponse>) {
      state.moduleDetails = action.payload;
    },

    clearModuleDetailsAction(state) {
      state.moduleDetails = undefined!;
    },
  },
});

export const {
  setModuleDetailsAction,
  clearModuleDetailsAction,
  setModulesAction,
  clearModulesAction,
} = modulesSlice.actions;

export const getModuleDetails = (state: RootState): ModulesState => state.modules;

export default modulesSlice.reducer;
